export default "skymp5-front/73f5f728eabe26353510bba7f7190314.png";